/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import Grid from '@material-ui/core/Grid'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Slide from '@material-ui/core/Slide'
import CloseIcon from '@material-ui/icons/Close'
import IconButton from '@material-ui/core/IconButton'
import Skeleton from '@material-ui/lab/Skeleton'
import YouTubeIcon from '@material-ui/icons/YouTube'
import BrokenImageIcon from '@material-ui/icons/BrokenImage'
import MobileStepper from '@material-ui/core/MobileStepper'
import Button from '@material-ui/core/Button'
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'
import { useStyles } from './styles'
import VideoCardList from '../VideoCardList'

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
))

const VideoSearchInsingth = ({
  open,
  videos,
  loading,
  handleClose,
  addToVideoItemList,
  activeStepSearch,
  handleNextSearchVideo,
  handleBackSearchVideo,
}) => {
  const classes = useStyles()

  return (
    <Dialog
      open={open}
      fullWidth
      TransitionComponent={Transition}
      maxWidth="lg"
      keepMounted
      onClose={handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>
        <Grid container>
          <Grid item sm={6}>
            <p>Añada videos a la lista de análisis</p>
          </Grid>
          <Grid className={classes.justify} item sm={6}>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Grid
          component="div"
          className={classes.gridList}
          container
          spacing={2}
        >
          {!loading ? (
            Array.isArray(videos.videoList) && videos.videoList.length > 0 ? (
              videos.videoList.map((video) => (
                <VideoCardList
                  key={video.videoId}
                  addToVideoItemList={addToVideoItemList}
                  video={video}
                  isSearch
                />
              ))
            ) : videos?.videoList?.error ? (
              <Grid container>
                <Grid sm={12} item className={classes.center}>
                  <BrokenImageIcon style={{ color: '#F70000', fontSize: 80 }} />
                </Grid>
                <Grid item sm={12} className={classes.center}>
                  <p> Lo sentimos llegamos al límite de búsquedas por día</p>
                </Grid>
              </Grid>
            ) : (
              <div className={classes.center}>
                <p> Búsca y añade un video </p>{' '}
                <YouTubeIcon style={{ color: '#F70000' }} alt="Ver Video - " />
              </div>
            )
          ) : (
            <>
              {[1, 2].map((value) => (
                <React.Fragment key={value}>
                  <div className={classes.containerImage}>
                    <Skeleton
                      animation="wave"
                      variant="rect"
                      width={480}
                      height={360}
                    />
                  </div>
                  <div className={classes.cardBodyList}>
                    <div className={classes.root}>
                      <Skeleton />
                      <Skeleton animation={false} />
                      <Skeleton animation="wave" />
                    </div>
                  </div>
                </React.Fragment>
              ))}
            </>
          )}
        </Grid>
      </DialogContent>
      {!loading ? (
        <MobileStepper
          variant="progress"
          steps={
            videos.pageInfo?.pageInfo.totalResults /
            videos.pageInfo?.pageInfo.resultsPerPage
          }
          position="static"
          activeStep={activeStepSearch}
          className={classes.root}
          nextButton={
            <Button
              size="small"
              onClick={handleNextSearchVideo}
              disabled={
                activeStepSearch ===
                videos.pageInfo?.pageInfo.totalResults /
                  videos.pageInfo?.pageInfo.resultsPerPage -
                  1
              }
            >
              Next
              <KeyboardArrowRight />
            </Button>
          }
          backButton={
            <Button
              size="small"
              onClick={handleBackSearchVideo}
              disabled={activeStepSearch === 0}
            >
              <KeyboardArrowLeft />
              Back
            </Button>
          }
        />
      ) : (
        <>
          <div className={classes.root}>
            <Skeleton />
            <Skeleton animation={false} />
            <Skeleton animation="wave" />
          </div>
        </>
      )}
    </Dialog>
  )
}

export default VideoSearchInsingth
